import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { Link } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Input,
    Button,
    FormGroup,
    Label
} from "reactstrap";

import { connect } from "react-redux";
import http from "../../../services/HttpService";
import validate from "../../../services/ValidationService";
import Route from "../../../Routes";
import { AUTH_LOGIN } from "../../../store/actions";
import Loading from "../../includes/Loading";
import { Translation } from "react-i18next";

//import LayoutMaster from "../../../views/layout/Master";
//import {layout} from "../../../../ts-helpers/decorators";

import LoginImage from "../../../../assets/img/site/login_image.png";

//@layout(LayoutMaster)
@(connect((state: any) => {
    return {
        isLogged: state.AuthReducer.isLogged,
        user: state.AuthReducer.user,
    };
}) as any)

export default class Login extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        errors: [],
        loading: false,
        submitted:false,
        email: {
            value: "",
            valid: false,
            touched: false,
        },
        password: {
            value: "",
            valid: false,
            touched: false,
        },
        newErrEmail:'',
        newErrPass:'',
        newErrVerify:''
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    @autobind
    validateEmail(event) {
        const { email } = this.state;
        email.value = event.target.value;
        email.valid = validate.email(event.target.value);
        email.touched = true;

        this.setState({
            email,
            newErrEmail:''
        });
    }

    @autobind
    validatePassword(event) {
        const { password } = this.state;
        password.value = event.target.value;
        password.valid = validate.password(event.target.value);
        password.touched = true;

        this.setState({
            password,
            newErrPass:''
        });
    }

    @autobind
    formSubmitSignIn(event) {
        event.preventDefault();

        this.setState({ submitted: true });
        this.setState({ loading: true });

        const { email, password } = this.state;
        if (!email.valid || !password.valid) {
            return;
        }

        const postData = {
            email: email.value,
            password: password.value,
        };

        http.post("/users/login", postData)
            .then((response: Response) => {
                if (response.ok) {
                    response.json().then((data: any) => {
                        if(data.status == 'success'){
                            this.props.dispatch({
                                type: AUTH_LOGIN,
                                payload: data,
                            });
                        }else{
                            if(data.verifyError){
                                this.setState({
                                    newErrVerify: data.verifyError,
                                    loading: false
                                });
                            }else{
                                this.setState({
                                    newErrEmail: "Invalid email or password",
                                    newErrPass: "Invalid email or password",
                                    loading: false
                                });
                            }
                        }
                    });
                } else {
                    response.json().then((jsonData: any) => {
                        this.setState({
                            errors: jsonData.errors,
                        });
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const { errors, email, password, loading, submitted, newErrPass, newErrEmail,newErrVerify } = this.state;

        if (this.props.isLogged) {
            return <Redirect to={Route.toUrl("dashboard_home")} />
        }

        return (
            <form onSubmit={this.formSubmitSignIn}>
                <div className="or-seperator_1"><b>Sign in</b></div>
                <div className="form-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        onChange={this.validateEmail}
                        value={email.value}
                    />
                    <div className='reg_errors_style'>
                        {validate.showError(email, "Invalid e-mail address")}
                        {validate.showDbError(errors, "email")}
                        {newErrEmail}
                    </div>
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        onChange={this.validatePassword}
                        value={password.value}
                    />
                    <div className='reg_errors_style'>
                        {validate.showError(password, "Invalid password: min 6 letter, at least one digit.")}
                        {validate.showDbError(errors, "password")}
                        {newErrPass}
                    </div>
                </div>
                {
                    newErrVerify != '' &&
                    <div className='reg_errors_style_verify'>
                        {newErrVerify}
                    </div>
                }

                <Button className="my_sign_in_submit" disabled={!email.valid || !password.valid} >
                    {submitted && loading ? <Loading isLoading={loading} icon="auth" /> : "Sign in"}
                </Button>
            </form>
        );
    }
}
